import {useCallback, useEffect, useMemo, useRef, useState} from 'react'
import { useSelector } from 'react-redux'
import { makeGetHandlesOnTopic } from 'reduxes/slices/participants/selectors'
import { useGetPublicContacts } from '../use_get_public_contact'
import { useSelectorDelegateStore } from 'reduxes/stores/root_store/hooks'
import Trix from 'trix'

import {getSelectedTopic} from "../../reduxes/slices/topics/selectors";
import Tribute from "tributejs";
import {getRoutes} from "../../reduxes/slices/routes/selectors";


export const useTrixMentions = (
  id,
  editorRef
) => {
  const topic = useSelector(getSelectedTopic)
  const getHandlesOnTopic = useMemo(makeGetHandlesOnTopic, [])
  const handles = useSelector((state) => getHandlesOnTopic(state, topic))
  const routes = useSelectorDelegateStore(getRoutes)
  const directChatPath = routes.admin_app_direct_chats_selected.path

  const publicContacts = useGetPublicContacts(handles)

  const pasteHtml = useCallback((html, startPos, endPos) => {
    let position = editorRef.current.getPosition()
    editorRef.current.setSelectedRange([position - (endPos - startPos), position])
    editorRef.current.deleteInDirection('backward')
  }, [editorRef])

  const replaced = useCallback((e) => {
    if (e && e.detail && e.detail.item) {
      let mention = e.detail.item.original
      let attachment = new Trix.Attachment({
        sgid: mention.attachable_sgid,
        content: '<a href="' + directChatPath.replace(':handle', mention.handle) + '">@' + mention.name + '</a>'
      })
      editorRef.current.insertAttachment(attachment)
      editorRef.current.insertString(' ')
    }
  }, [directChatPath, editorRef])

  useEffect(() => {
    if (editorRef.current && publicContacts) {
      const editor = editorRef.current
      const element = editor.element
      const tribute = new Tribute({
        values: Object.values(publicContacts).filter(pc => !!pc.attachable_sgid).sort((pc1, pc2) => pc1.handle > pc2.handle ? 1 : -1),
        lookup: 'name',
        spaceSelectsMatch: true,
      });
      tribute.attach(element)
      tribute.range.pasteHtml = pasteHtml
      element.addEventListener('tribute-replaced', replaced)

      return () => {
        element.removeEventListener('tribute-replaced', replaced)
        tribute.detach(element);
      }
    }
  }, [editorRef, editorRef.current, pasteHtml, publicContacts, replaced])
}
